// 组件列表
const components = []
const componentList = require.context("./", true, /\.js$/)
componentList.keys().forEach(fileName => {
  if (fileName.startsWith("./index")) {
    return
  }
  const file = componentList(fileName)
  components.push(file.default || file)
})

export default components